<template>
  <div>
    <q-card
      :class="['container_box shadow-1', isAuthorized ? 'clickable' : '']"
      data-cy="container-servicio"
    >
      <div @click="openURL" :class="[isAuthorized ? 'clickable cursor-pointer' : '']">
        <div
          class="col-12 row"
          style="height: 94px; max-height: 85px; padding: 16px 16px 0 16px"
        >
          <div class="col-2 containerLogo">
            <q-img :src="imgLogotipo" contain class="logotipo"/>
          </div>
          <div class="col-10 TextName">
            {{ datos.name }}
          </div>
        </div>
        <div
          class="espacios TextDescription"
          style="margin-left: 16px; margin-right: 10px; height: 70px; padding: 5px;"
        >
          {{ datos.description }}
        </div>
        <div class="col-12 row imagenContainer">
          <q-img :src="imgImagen" width="100%" height="181px" class="Imagen">
          </q-img>
        </div>
      </div>
      <div class="absolute-bottom Rectangle">
        <div class="col-12 row footerContainer">
          <q-img
            data-cy="icon-video-servicio"
            v-if="isResource(this.servicio.resources, 'Video')"
            :src="require('@/assets/img/video-icono-back.svg')"
            height="24px"
            width="24px"
            style="margin-left: 10px"
            @click.capture.stop="showVideoPopup(servicio)"
            class="cursor-pointer"
          />
          <a
          v-if="urlServicio != null"
          :href="SanitizeUrl(urlServicio)"
          target="_blank"
          rel="noopener noreferrer"
          >
            <q-icon
              data-cy="icon-url-servicio"
              :name="'img:' + require('@/assets/img/url_icon_black.svg')"
              style="margin-left: 10px; height: 24px; width: 24px;"></q-icon>
          </a>
          <a
            v-if="isResource(servicio.resources, 'Documento')"
            :href="SanitizeUrl(this._getResource(servicio.resources, 'Documento'))"
            download
            target="_blank"
            rel="noopener noreferrer"
          >
            <q-icon
            data-cy="icon-documento-servicio"
            :name="'img:' + require('@/assets/img/pdf-icono-back.svg')"
            style="margin-left: 10px; height: 24px; width: 24px;"></q-icon>
          </a>
        </div>
      </div>
    </q-card>
    <q-dialog v-model="videoPopup" style="min-width: 550px" :bordered="false">
      <div class="col-12 row">
        <video style="margin: auto;" height="495" controls autoplay muted loop>
          <source :src="videoSelected" />
          Your browser does not support the video tag.
        </video>
      </div>
    </q-dialog>
  </div>
</template>

<script>
import Formats from '@/components/shared/mixins/Formats.js';
import { QCard, QImg, QDialog } from 'quasar';
import Resources from '@/components/shared/mixins/Resources.js';

export default {
  components: {
    QImg,
    QDialog,
    QCard
  },
  props: {
    datos: Object
  },
  mixins: [Formats, Resources],
  data () {
    return {
      videoPopup: false,
      videoSelected: null,
      servicio: null,
      imgLogotipo: null,
      imgImagen: null,
      urlServicio: null,
      SanitizeUrl: require('@braintree/sanitize-url').sanitizeUrl
    };
  },
  computed: {
    isAuthorized () {
      // TODO TEMPORALMENTE LO HACEMOS ASI
      let exist = false;

      if (
        this.datos.aplicaciones &&
        this.datos.aplicaciones.length > 0 &&
        this.datos.aplicaciones[0].url
      ) {
        exist = true;
      }

      return exist;
      // TODO DEJAMOS CODIGO COMENTADO PARA SU USO FUTURO
      /*
      let appsAuthorized = this.$store.state.PF.user.appAuthorized;
      let idApp = this.datos.id;
      let resultCheck = [];
      let exist = false;

      resultCheck = appsAuthorized.filter((e) => e === idApp);

      if (resultCheck.length > 0) {
        exist = true;
      }
      return exist;
      */
    }
  },
  methods: {
    openURL () {
      if (this.isAuthorized) {
        window.open(this.servicio.aplicaciones[0].url, '_blank');
      } else {
        // TODO Redirect New method?
      }
    },
    async refillData () {
      let resources = this.servicio.resources;

      let logotipo = this.searchResource(resources, 'Logotipo');
      let imagen = this.searchResource(resources, 'Imagen');
      this.urlServicio = this.servicio.hasOwnProperty('url') && this.servicio.url !== '' ? this.servicio.url : null;

      this.imgLogotipo =
        logotipo !== null ? logotipo.url : this.getDefaultResource('Logotipo');
      this.imgImagen =
        imagen !== null ? imagen.url : this.getDefaultResource('Imagen');
    },
    _getResource (d, search) {
      let resource = this.searchResource(d, search);
      if (resource === null) {
        return this.getDefaultResource(search);
      }
      return resource.url;
    },
    showVideoPopup (servicio) {
      this.videoPopup = true;
      this.videoSelected = this._getResource(servicio.resources, 'Video');
    },
    isResource (resource, typeResource) {
      return this._getResource(resource, typeResource) !== '';
    }
  },
  watch: {
    datos: {
      handler: function () {
        this.servicio = this.datos;
        if (Object.entries(this.datos).length > 0) {
          this.refillData();
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.container_box {
  &.clickable {
    transition: box-shadow 0.3s;
    &:hover {
      box-shadow: $shadow-8;
    }
  }
  padding: 0 !important;
  height: 336px;
  background-color: #ffffff;
}

.containerLogo {
  margin-top: 3px;
}

.paddingInfo {
  padding-top: 24px;
  padding-left: 24px;
  padding-right: 24px;
  padding-bottom: 24px;
}

.logotipo {
  width: 40px;
  height: 40px;
}

.imageContainer {
  height: 71px;
  max-height: 71px;
}
.Imagen {
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}
.Rectangle {
  width: 100%;
  height: 43px;
  background-color: rgba(255, 255, 255, 0.9);
  padding: 7px 16px 0 16px;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}

.TextName {
  @include tallFont;
  font-size: 19px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.25px;
  color: rgb(0, 47, 108);
}
.TextDescription {
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: 0.21px;
  color: black;
}
.Informacion {
  width: 20px;
  height: 20px;
  color: rgba(0, 0, 0, 64);
}
.error-img {
  background-color: #eeeeee;
  color: #9c9c9c;
}
.footerContainer{
  float: right;
}
</style>
